export class ViewPermissions {
  oneWayQuote = true;
  emailConfiguration = true;
  fulfillFlights = true;
  publishedPrivateFlights = true;
  publishedFlights = true;
  privateFlightsFlexibility = true;
  actOnBehalfOfAnyOperator = false;
}
